const removeVietnameseTones = (str) => {
  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D");
};

const toSlug = (name, masp) => {
  return (
    removeVietnameseTones(name)
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, "") // Xóa ký tự đặc biệt
      .trim()
      .replace(/\s+/g, "-") // Thay khoảng trắng bằng "-"
      .replace(/-+/g, "-") // Xóa nhiều dấu "-" liên tiếp
      + `-${masp}` // Thêm masp để đảm bảo slug duy nhất
  );
};

const sortWeights = (weights) => {
  return weights
    .filter((w) => w !== undefined && w !== null && w !== "Không xác định")
    .sort((a, b) => {
      // Tách giá trị số và đơn vị
      const regex = /^(\d+\.?\d*)([a-zA-Z]+)$/;
      const matchA = a.match(regex);
      const matchB = b.match(regex);

      if (!matchA || !matchB) return 0; // Nếu không khớp, giữ nguyên thứ tự

      const valueA = parseFloat(matchA[1]);
      const unitA = matchA[2].toLowerCase();
      const valueB = parseFloat(matchB[1]);
      const unitB = matchB[2].toLowerCase();

      // Quy đổi về gram để so sánh
      const toGrams = (value, unit) => {
        if (unit === "kg") return value * 1000;
        if (unit === "g") return value;
        return value; // Mặc định giữ nguyên nếu đơn vị không xác định
      };

      return toGrams(valueA, unitA) - toGrams(valueB, unitB);
    });
};

const toCategoryKey = (category) => {
  if (!category) return '';
  return category
    .toLowerCase()
    .normalize('NFD') // Chuẩn hóa ký tự Unicode
    .replace(/[\u0300-\u036f]/g, '') // Loại bỏ dấu
    .replace(/đ/g, 'd') // Thay 'đ' bằng 'd'
    .replace(/[\s+]/g, '-') // Thay khoảng trắng bằng dấu gạch ngang
    .replace(/[^\w-]/g, '') // Xóa ký tự không phải chữ, số, hoặc dấu gạch ngang
    .replace(/-+/g, '-') // Thay nhiều dấu gạch ngang liên tiếp bằng một dấu
    .trim();
};

export { toSlug, sortWeights, toCategoryKey };